import { Injectable } from '@angular/core';
import { AjaxResponse } from 'rxjs/ajax';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseRequester } from '../common/base-requester';
import {
    RenderPersistRequest,
    RenderPersistResponse,
    RenderPersistWireRequest,
} from './interfaces/render-persist-request';
@Injectable({
    providedIn: 'root',
})
export class RenderPersistReportService extends BaseRequester {
    constructor() {
        super();
    }

    public renderAndGetSharedUrl<T>(
        request: RenderPersistRequest<T>,
    ): Observable<RenderPersistResponse> {
        const wireRequest: RenderPersistWireRequest = {
            renderFunctionName: environment.renderReportFunctionName,
            renderRequestPayload: {
                body: JSON.stringify(request.renderRequest),
            },
            reportStoreRequest: request.reportStoreRequest,
        };
        return this.internalPostRequest(
            environment.renderPersistReportEndpoint,
            wireRequest,
        ).pipe(
            map((response: AjaxResponse) => {
                if (!response.response.errorMessage) {
                    return response.response;
                } else {
                    throw new Error(
                        RenderPersistReportService.toUserMessage(
                            response.response.errorMessage || response.response,
                            request.reportStoreRequest.parents,
                        ),
                    );
                }
            }),
        );
    }

    // Drive answers a parent folder the uploader service account cannot see
    // with a 404 "File not found: <id>" — indistinguishable from a deleted
    // folder, and the bare id tells the operator nothing. Name the real
    // remedy: the folder must be shared (Editor) with the Lambda's uploader
    // account. Seen 2026-08-21 on the receipt page, whose archive folder had
    // been configured but never shared.
    private static toUserMessage(
        errorMessage: unknown,
        parents: string[],
    ): string {
        const text = String(errorMessage);
        const match = /File not found: (\S+?)\.?$/.exec(text);
        if (match && parents.includes(match[1])) {
            return (
                `Google Drive folder ${match[1]} is not accessible to the ` +
                'render-persist uploader service account (not shared with it, ' +
                'or deleted). Share the folder with that account as Editor, ' +
                'or point the environment folder id at one that is, then retry.'
            );
        }
        return text;
    }
}
